/**
 * Customers Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const customersAPI = {
  getAll: (params) => apiClient.get('/customers', { params }),
  getById: (id) => apiClient.get(`/customers/${id}`),
  getSummary: (params) => apiClient.get('/customers/stats/summary', { params }),
  create: (data) => apiClient.post('/customers', data),
  update: (id, data) => apiClient.put(`/customers/${id}`, data),
  updateFinancials: (id) => apiClient.patch(`/customers/${id}/financials`),
  delete: (id) => apiClient.delete(`/customers/${id}`),
};

export default customersAPI;

